<script lang="ts" setup>
  import type { LobbyView } from '../../../../shared/api/lobby.ts';
  import LobbyLayout from './LobbyLayout.vue';
  import PlayersAndInvitation from './PlayersAndInvitation.vue';

  defineProps<{ data: LobbyView; showRules: boolean }>();
</script>

<template>
  <LobbyLayout :game-code="data.gameCode" :rounds="data.gameConfig.rounds" :show-rules="showRules">
    <PlayersAndInvitation :game-code="data.gameCode" :player="data.player" :players="data.players" />

    <h2 class="waiting-message">Waiting for {{ data.hostPlayer.nickname }} to start the game...</h2>
  </LobbyLayout>
</template>

<style scoped>
  .waiting-message {
    align-items: center;
    color: var(--color-text-muted);
    display: flex;
    font-size: var(--font-size-md);
    justify-content: center;
    margin: 0;
    max-width: var(--control-max-width);
    min-height: var(--lobby-action-height);
    text-align: center;
    width: 100%;
  }
</style>
